import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";

const {RADIO_BUTTON, INPUT, CHECKBOX, TEXT_AREA} = FIELD_TYPE;

const labelCol = {xs: 6, md: 6, lg: 6};
const wrapperCol = {xs: 18, md: 18, lg: 18};
const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};

export const FieldsCornea1: any[] = [
  {
    name: ["rightJsonValue", "CORNEA", "Kích thước"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Kích thước",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Nhỏ",
        value: "Nhỏ",
        span: 8,
      },

      {
        label: "To",
        value: "To",
        span: 8,
      },
    ],
  },
  {
    name: ["rightJsonValue", "CORNEA", "Hình dạng"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hình dạng",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 6,
      },
      {
        label: "Bất đối xứng",
        value: "Bất đối xứng",
        span: 6,
      },
      {
        label: "Giác mạc chóp",
        value: "Giác mạc chóp",
        span: 6,
      },
      {
        label: "Giác mạc hình cầu",
        value: "Giác mạc hình cầu",
        span: 6,
      },
    ],
  },

  {
    name: ["rightJsonValue", "CORNEA", "Bề mặt"],
    label: "Bề mặt",
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    checkbox: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 6,
      },
      {
        label: "Tổn thương",
        value: "Tổn thương",
        span: 6,
      },
      {
        label: "Mỏng",
        value: "Mỏng",
        span: 6,
      },
      {
        label: "Sẹo",
        value: "Sẹo",
        span: 6,
      },
      {
        label: "Tân mạch",
        value: "Tân mạch",
        span: 6,
      },
      {
        label: "Thoái hóa",
        value: "Thoái hóa",
        span: 6,
      },
      {
        label: "Loạn dưỡng",
        value: "Loạn dưỡng",
        span: 6,
      },
      {
        label: "Dị vật",
        value: "Dị vật",
        span: 6,
      },
      {
        label: "Rách",
        value: "Rách",
        span: 6,
      },
      {
        label: "Tủa sau giác mạc",
        value: "Tủa sau giác mạc",
        span: 6,
      },
      {
        label: "Đục giác mạc",
        value: "Đục giác mạc",
        span: 6,
      },
      {
        label: "Loét",
        value: "Loét",
        span: 6,
      },
      {
        label: "Chỉ khâu",
        value: "Chỉ khâu",
        span: 6,
      },
      {
        label: "Mảnh ghép",
        value: "Mảnh ghép",
        span: 6,
      },
      {
        label: "Kính áp tròng",
        value: "Kính áp tròng",
        span: 6,
      },
      {
        label: "Phù",
        value: "Phù",
        span: 6,
      },
    ],
  },
  {
    name: ["rightJsonValue", "CORNEA", "Bắt màu Fluorescein"],
    label: "Bắt màu Fluorescein",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Dương tính",
        value: "Dương tính",
        span: 8,
      },
      {
        label: "Âm tính",
        value: "Âm tính",
        span: 8,
      },
    ],
  },
  {
    name: ["rightJsonValue", "CORNEA", "Cảm giác giác mạc"],
    label: "Cảm giác giác mạc",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Mất",
        value: "Mất",
        span: 8,
      },
      {
        label: "Giảm",
        value: "Giảm",
        span: 8,
      },
    ],
  },
  {
    type: INPUT,
    suffix: "mm",
    label: "Test Schirmer 1",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["rightJsonValue", "CORNEA", "Test Schirmer 1"],
  },
  {
    type: INPUT,
    suffix: "phút",
    className: "in-text-inside",
    label: "trong",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["rightJsonValue", "CORNEA", "Test Schirmer 1Inside"],
  },
  {
    type: INPUT,
    suffix: "mm",
    label: "Test Schirmer 2",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["rightJsonValue", "CORNEA", "Test Schirmer 2"],
  },
  {
    type: INPUT,

    suffix: "phút",
    className: "in-text-inside",
    label: "trong",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["rightJsonValue", "CORNEA", "Test Schirmer 2Inside"],
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "CORNEA", "show"],
    hide: true,
  },
];

export const FieldsCornea2: any[] = [
  {
    name: ["leftJsonValue", "CORNEA", "Kích thước"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Kích thước",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Nhỏ",
        value: "Nhỏ",
        span: 8,
      },

      {
        label: "To",
        value: "To",
        span: 8,
      },
    ],
  },
  {
    name: ["leftJsonValue", "CORNEA", "Hình dạng"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hình dạng",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 6,
      },
      {
        label: "Bất đối xứng",
        value: "Bất đối xứng",
        span: 6,
      },
      {
        label: "Giác mạc chóp",
        value: "Giác mạc chóp",
        span: 6,
      },
      {
        label: "Giác mạc hình cầu",
        value: "Giác mạc hình cầu",
        span: 6,
      },
    ],
  },

  {
    name: ["leftJsonValue", "CORNEA", "Bề mặt"],
    label: "Bề mặt",
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    checkbox: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 6,
      },
      {
        label: "Tổn thương",
        value: "Tổn thương",
        span: 6,
      },
      {
        label: "Mỏng",
        value: "Mỏng",
        span: 6,
      },
      {
        label: "Sẹo",
        value: "Sẹo",
        span: 6,
      },
      {
        label: "Tân mạch",
        value: "Tân mạch",
        span: 6,
      },
      {
        label: "Thoái hóa",
        value: "Thoái hóa",
        span: 6,
      },
      {
        label: "Loạn dưỡng",
        value: "Loạn dưỡng",
        span: 6,
      },
      {
        label: "Dị vật",
        value: "Dị vật",
        span: 6,
      },
      {
        label: "Rách",
        value: "Rách",
        span: 6,
      },
      {
        label: "Tủa sau giác mạc",
        value: "Tủa sau giác mạc",
        span: 6,
      },
      {
        label: "Đục giác mạc",
        value: "Đục giác mạc",
        span: 6,
      },
      {
        label: "Loét",
        value: "Loét",
        span: 6,
      },
      {
        label: "Chỉ khâu",
        value: "Chỉ khâu",
        span: 6,
      },
      {
        label: "Mảnh ghép",
        value: "Mảnh ghép",
        span: 6,
      },
      {
        label: "Kính áp tròng",
        value: "Kính áp tròng",
        span: 6,
      },
      {
        label: "Phù",
        value: "Phù",
        span: 6,
      },
    ],
  },
  {
    name: ["leftJsonValue", "CORNEA", "Bắt màu Fluorescein"],
    label: "Bắt màu Fluorescein:",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Dương tính",
        value: "Dương tính",
        span: 8,
      },
      {
        label: "Âm tính",
        value: "Âm tính",
        span: 8,
      },
    ],
  },
  {
    name: ["leftJsonValue", "CORNEA", "Cảm giác giác mạc"],
    label: "Cảm giác giác mạc",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Mất",
        value: "Mất",
        span: 8,
      },
      {
        label: "Giảm",
        value: "Giảm",
        span: 8,
      },
    ],
  },
  {
    type: INPUT,
    suffix: "mm",
    label: "Test Schirmer 1",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["leftJsonValue", "CORNEA", "Test Schirmer 1"],
  },
  {
    type: INPUT,

    suffix: "phút",
    className: "in-text-inside",
    label: "trong",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["leftJsonValue", "CORNEA", "Test Schirmer 1Inside"],
  },
  {
    type: INPUT,
    suffix: "mm",
    label: "Test Schirmer 2",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["leftJsonValue", "CORNEA", "Test Schirmer 2"],
  },
  {
    type: INPUT,

    suffix: "phút",
    className: "in-text-inside",
    label: "trong",
    css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
    labelCol: {xs: 12, md: 12, lg: 12},
    wrapperCol: {xs: 12, md: 12, lg: 12},
    name: ["leftJsonValue", "CORNEA", "Test Schirmer 2Inside"],
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "CORNEA", "show"],
    hide: true,
  },
];
const fieldsCommentLeft = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "CORNEA", "Ghi chú"],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
  },
];
const fieldsCommentRight = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "CORNEA", "Ghi chú"],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
  },
];
export {fieldsCommentLeft, fieldsCommentRight};
